module.exports = __webpack_public_path__ + "static/media/INCUBATION.e295616d.webp";